import Icon from "@chakra-ui/icon";
import React from "react";
export default function DeleteIcon({ height, width }: any | undefined) {
  return (
    <Icon
      height={height}
      width={width}
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.7522 14C1.7522 14.8273 2.42495 15.5 3.2522 15.5H10.7522C11.5794 15.5 12.2522 14.8273 12.2522 14V5H13.7522V3.5H10.7522V2C10.7522 1.17275 10.0794 0.5 9.2522 0.5H4.7522C3.92495 0.5 3.2522 1.17275 3.2522 2V3.5H0.252197V5H1.7522V14ZM4.7522 2H9.2522V3.5H4.7522V2ZM4.0022 5H10.7522L10.7529 14H3.2522V5H4.0022Z"
        fill="#FF8787"
      />
      <path
        d="M4.7522 6.5H6.2522V12.5H4.7522V6.5ZM7.7522 6.5H9.2522V12.5H7.7522V6.5Z"
        fill="#FF8787"
      />
    </Icon>
  );
}
